var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('area-layer',{on:{"layer":function($event){return _vm.onLayer($event, 1)}}}),_vm._v(" "),_c('yeti-layer',{on:{"layer":function($event){return _vm.onLayer($event, 0)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }